import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { FC } from 'react'

import Loader from '@segment/matcha/components/Loader'

import { useFiltersQuery } from '@segment/api/routes/growthMasters/queries'
import type { GroupedFilters } from '@segment/api/routes/growthMasters/types'

import Layout from '../components/Layout'
import WantToLearnMore from '../components/WantToLearnMore'

import Filters from './Filters'

import GrowthMastersCurriculum from './GrowthMastersCurriculum'
import { useCurriculumGrid } from './hooks/useCurriculumGrid'
import { useFilters } from './hooks/useFilters'
import Cards from './Cards'

const Curriculum: FC = () => {
  const { data: filters } = useFiltersQuery({ args: [] })
  const groupedFilterEntries = Object.entries((filters as GroupedFilters) || {})
  const { filtersState, selectHandlers } = useFilters(groupedFilterEntries)
  const { pages, nextPageTrigger, isLoading, hasNextPage, isFetchingNextPage } = useCurriculumGrid(filtersState)

  return (
    <Layout pageName="Curriculum">
      <GrowthMastersCurriculum />
      <Filters
        filters={groupedFilterEntries}
        onFilterChange={(filterId, selectedOptions) => selectHandlers[filterId](selectedOptions)}
      />
      <Wrapper>
        {!isLoading && <Cards lessons={pages} />}
        {isLoading && (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        )}
        {hasNextPage && (
          <LoaderWrapper compensateTopGutter={hasNextPage}>{isFetchingNextPage && <Loader />}</LoaderWrapper>
        )}
        {nextPageTrigger}
      </Wrapper>

      {!hasNextPage && <WantToLearnMore />}
    </Layout>
  )
}

const Wrapper = styled.div``

interface LoaderWrapperProps {
  compensateTopGutter?: boolean
}

const LoaderWrapper = styled.div<LoaderWrapperProps>`
  display: grid;
  align-items: center;
  justify-content: center;
  height: 400px;
  padding: 80px 0;
  margin: 0 auto;
  ${({ compensateTopGutter }) =>
    compensateTopGutter &&
    css`
      padding: 0;
      margin-top: -120px;
    `}
`

export default Curriculum
